import { useState } from "react";

import Button from "../../../../../common/Button";
import { getViewDownloadLinkForProcoDocs } from "../../../../../../lib/fetchApi";
import { documentHasFileId } from "../../../../../../lib/docs";
import { caseActions } from "../../../../../../store/case";
import { useDispatch } from "react-redux";

export default function DownloadDocument({children, userToken, activeCase, item, btnStyle, extraAction, docType}) {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    if (!documentHasFileId(item)) {
        return null
    }

    async function downloadDocumentHandler() {
        setLoading(true)
        let doc = await getViewDownloadLinkForProcoDocs(userToken, activeCase.case.id, docType, item.id)

        if (doc && doc.view_url) {
            var win = window.open(doc?.download_url);
            win.focus();
            // Only Law Firm uploads track "viewed" — ProCo source docs must stay unviewed
            if (item.source === 'Law Firm') {
                dispatch(caseActions.markDocumentAsViewed(item))
            }
        }
        if (extraAction) {
            extraAction()
        }
        setLoading(false)
    }

    return <Button title='download document' btnStyle={btnStyle} click={downloadDocumentHandler} isLoading={loading} loaderType={'dark'}>{children}</Button>
}